import React, { useState, useEffect } from 'react';
import { getStrapiMedia } from '../../../lib/media';
import NextImage from 'next/image';
import { ImageWrapper, FullscreenButton } from './style';
import { uid } from 'react-uid';
import { Button } from '../../styleguide-remapped/styleguide-remapped';
import { default as Fullscreen2 } from '../../../assets/logos/fullscreen2';
import ImageOverlay from './ImageOverlay';
import { getCookie } from 'cookies-next';

const Image = ({ block, documentData, pageType }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  // Pick whichever node actually carries a url so the src and the derived
  // attributes (alt/width/height) always come from the same media entry.
  const mediaNode = block.media?.data?.attributes?.url ? block.media : block.image;
  const imageSrc = getStrapiMedia(mediaNode);

  if (!imageSrc) {
    return null;
  }

  const { alternativeText, width, height } = mediaNode?.data?.attributes ?? {};
  const description = block.description ?? block.imageDescription;
  const alignment = block.alignment || 'Mittig';

  const toggleOverlay = () => {
    setIsOverlayOpen((prevState) => {
      document.body.style.overflow = prevState ? '' : 'hidden';
      return !prevState;
    });
  };

  return (
    <ImageWrapper alignment={alignment}>
      <div className="image-container">
        <NextImage
          key={uid(block)}
          width={width || '100%'}
          height={height || '100%'}
          src={imageSrc}
          alt={alternativeText || ''}
          title={alternativeText || ''}
          onClick={toggleOverlay}
          style={{ cursor: 'pointer' }}
        />
        <FullscreenButton className="fullscreen-button">
          <Button
            onClick={toggleOverlay}
            isIconOnly={true}
            iconLeft={<Fullscreen2 />}
            ariaLabel="Bild in Vollansicht öffnen"
            text="Bild in Vollansicht öffnen"
            type="text"
          />
        </FullscreenButton>
      </div>
      {description && <p className="small-text">{description}</p>}

      {isOverlayOpen && (
        <ImageOverlay
          isVisible={isOverlayOpen}
          id={`image-${uid(block)}`}
          onClose={toggleOverlay}
          image={imageSrc}
          alt={alternativeText}
          title={alternativeText}
          description={description}
        />
      )}
    </ImageWrapper>
  );
};

export default Image;
